export default __webpack_public_path__ + "static/media/RELEASE_BLOCKS_ICON.b9f73577.svg";